module.exports = __webpack_public_path__ + "img/dink-kitchen-5.fd449d85.jpeg";